import { handleActions } from 'redux-actions';
import produce from 'immer';
import * as types from '@src/store/types';

const initialState = {
	showPageLoading: true,
	themeState: 'IDLE',
	themes: {},
};

/**
 * 專門用於 CSR（Client-Side Rendering）的主題資料流程。
 *
 * 背景說明：
 * 原本 theme 資料為 SSR 與 CSR 共用流程，但由於 SSR 階段缺乏 token，
 * 在未登入或權限不足的情況下會取得預設值，導致 hydration 後覆蓋掉 client 正確資料。
 *
 * 解法：
 * 拆分出一組 client 專用的 themeClient 流程（API 相同），僅於畫面載入後由 CSR 呼叫，
 * 避免 SSR 的 default 資料污染畫面狀態。
 *
 * 使用場景：
 * 僅限 client 環境下主動取得主題資料（如進入畫面時 useEffect 觸發），
 * 不應搭配 getServerSideProps 使用。
 */

export default handleActions(
	{
		[types.GET_THEMES_CLIENT_DONE](state, { payload }) {
			return produce(state, draft => {
				draft.showPageLoading = false;
				draft.themeState = 'SUCCESS';
				draft.themes = payload;
			});
		},
		[types.GET_THEMES_CLIENT_CALL](state, { payload }) {
			return produce(state, draft => {
				draft.showPageLoading = !payload.disableLoading;
				draft.themeState = 'LOADING';
			});
		},
		[types.GET_THEMES_CLIENT_FAIL](state, { payload }) {
			return produce(state, draft => {
				if (payload?.response?.status === 403) {
					draft.themeState = 'NOT_FOUND';
				} else if (payload?.response?.status === 402) {
					draft.themeState = 'PAYMENT_REQUIRED';
				} else {
					draft.themeState = 'FAIL';
				}
			});
		},
	},
	initialState,
);
